import type { ProductPricesWithDiscount } from "@frend-digital/centra/types/product";

import type { Sizes } from "@/features/product/components/ProductActions/ActionSection";

import { CentraSelectionItem } from "@frend-digital/centra/schemas/selection/selectionProductSchema";
import type { ProductCard } from "../formatters/formatProductCards/formatProductCard";

interface CartItemPDPType {
  name?: string;
  uri?: string;
  variantName?: string;
  sizes?: {
    itemId: string;
    name: string;
  }[];
  prices?: ProductPricesWithDiscount;
  media?: {
    href: string;
    alt: string;
  }[];
}

const createMedia = (media: string) => {
  return {
    standard: [media],
    full: [media]
  };
};

export const convertProductToCartItem = (
  product: CartItemPDPType,
  itemId: string
): CentraSelectionItem => {
  // Create media objects
  const firstImage = product.media?.at(0);
  const media = createMedia(firstImage?.href || "");

  const cartItem = {
    item: itemId,
    line: crypto.randomUUID(),
    product: {
      ...product,
      name: product?.name,
      uri: product.uri,
      media: media
    },
    quantity: 1,
    priceEach: product?.prices?.price,
    size: product?.sizes?.find((size) => size.itemId === itemId)?.name
  } satisfies CentraSelectionItem;

  return cartItem;
};

export const convertProductCardToCartItem = (
  product: ProductCard,
  size: Sizes["selectedSize"],
  prices?: ProductPricesWithDiscount
): CentraSelectionItem => {
  const media = createMedia(product?.gallery?.image?.href || "");

  const cartItem = {
    item: size?.itemId || "",
    line: crypto.randomUUID(),
    product: {
      variantName: product?.core?.variantName,
      name: product?.core?.name || "",
      uri: product?.core?.slug || "",
      media: media,
      quantity: 1,
      priceEach: prices?.price
    },
    size: size?.name
  } satisfies CentraSelectionItem;

  return cartItem;
};
